import { render, staticRenderFns } from "./FileCurriculum.vue?vue&type=template&id=89c91b1e"
import script from "./FileCurriculum.vue?vue&type=script&lang=js"
export * from "./FileCurriculum.vue?vue&type=script&lang=js"
import style0 from "./FileCurriculum.vue?vue&type=style&index=0&id=89c91b1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports